import { CustomArrowProps } from 'react-slick';
import { tw } from 'twind';
import { useCartStore } from 'store/cart';
import { ArrowLeftIcon } from '@heroicons/react/outline';

const PrevArrow = ({ onClick }: CustomArrowProps) => {
  const { theme } = useCartStore();
  return (
    <div
      className={tw`absolute flex justify-center items-center bg-${theme ?? 'OneItem'} border-${
        theme ?? 'OneItem'
      } w-8 h-8 px-1 py-1 cursor-pointer`}
      style={{
        top: '50%',
        transform: 'translate(0, -50%)',
        left: '-32px',
      }}
      onClick={onClick}
    >
      <ArrowLeftIcon className={tw`h-5 w-5 aria-hidden="true text-[#ffffff]`} />
    </div>
  );
};

export default PrevArrow;
